/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

console.log('tema de desarrollo');

//document.cookie = "username=Carlos; expires=Thu, 14 Jan 2021 12:00:00 UTC";
//var cook=document.cookie.indexOf('cookie_name=');
//var cook=document.cookie;
//console.log(cook);




if(screen.width > 641){
var popup='<div class="stores-modal">'
      + ' <div class="stores-modal-content">'
            //+'<span class="stores-close-button">&times;</span>'
           + '<h1>Elige tu tienda</h1>'

+'<input type="image" src="https://cdn.shopify.com/s/files/1/0266/6368/2128/files/monterreyhq.png?v=1626654650" id="mty" class="city-button"><input type="image" src="https://cdn.shopify.com/s/files/1/0266/6368/2128/files/cdmxhq.png?v=1626654650" id="cdmx" class="city-button"><input type="image" src="https://cdn.shopify.com/s/files/1/0266/6368/2128/files/guadalajarahq.png?v=1626654650" id="guad" class="city-button"><input type="image" src="https://cdn.shopify.com/s/files/1/0582/8401/5785/files/GH_Queretaro_Web.png?v=1634652698" id="qro" class="city-button"><input type="image" src="https://cdn.shopify.com/s/files/1/0266/6368/2128/files/saltillohq.png?v=1626654650" id="sal" class=" city-button"><input type="image" src="https://cdn.shopify.com/s/files/1/0609/3019/5700/files/GH_Botones_Ciudades_Web-_1.png?v=1646155852" id="chi" class="city-button"><input type="image" src="https://cdn.shopify.com/s/files/1/0610/6175/9199/files/GH_Botones_Metepec_Web.png?v=1648474822" style="" id="mtp" class="city-button"><input type="image" src="https://cdn.shopify.com/s/files/1/0482/4544/0674/files/GH_Boton_Nacioneles_Web.png?v=1633143612" id="nac" class="city-button">'


 +'</div></div>';
}else{
var popup='<div class="stores-modal">'
      + ' <div class="stores-modal-content">'
            //+'<span class="stores-close-button">&times;</span>'
           + '<h1>Elige tu tienda</h1>'
+'<input type="image" src="https://cdn.shopify.com/s/files/1/0266/6368/2128/files/monterrey_mob.png?v=1626655993" id="mty" class="city-button">'
+'<input type="image" src="https://cdn.shopify.com/s/files/1/0266/6368/2128/files/cdmx_mob.png?v=1626655993" id="cdmx" class="city-button">'
+'<input type="image" src="https://cdn.shopify.com/s/files/1/0266/6368/2128/files/guadalajara_mob.png?v=1626655993" id="guad" class="city-button">'
+'<input type="image" src="https://cdn.shopify.com/s/files/1/0582/8401/5785/files/GH_Queretaro_Movil.png?v=1634652698" id="qro" class="city-button">'
//+'<input type="image" src="https://cdn.shopify.com/s/files/1/0266/6368/2128/files/queretaro_mob.png?v=1626655993" id="qro" class="city-button">'
      +'<input type="image" src="https://cdn.shopify.com/s/files/1/0266/6368/2128/files/saltillo_mob.png?v=1626655993" id="sal" class=" city-button">'
+'<input type="image" src="https://cdn.shopify.com/s/files/1/0609/3019/5700/files/GH_Botones_Ciudades_Movil-_1.png?v=1646155853" id="chi" class="city-button">'
+'<input type="image" src="https://cdn.shopify.com/s/files/1/0610/6175/9199/files/GH_Botones_Metepec_Movil.png?v=1648474822" style="" id="mtp" class="city-button">'
+'<input type="image" src="https://cdn.shopify.com/s/files/1/0482/4544/0674/files/GH_Boton_Nacionales_Movil.png?v=1633143612" id="nac" class="city-button">'





 +'</div></div>';
}


 
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + ";domain=grillhouse.mx; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=;domain=grillhouse.mx; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
 

document.addEventListener('DOMContentLoaded', function(){ 
  
  var cont=document.getElementById('shopify-section-announcement-bar');
 
 cont.innerHTML += popup;
  //document.body.innerHTML = document.body.innerHTML + '';
  function toggleModal() {
        modal.classList.toggle("stores-show-modal");
    }

  function setStore(store){
    console.log('store: '+store);
    if(store=='cdmx'){
      eraseCookie('store');
      setCookie('store','cdmx',365);
      window.location.replace("https://www.cdmx.grillhouse.mx/?"+'&str='+store);     
    }
    else if(store=='gdl'){
      eraseCookie('store');
      setCookie('store','gdl',365);
      window.location.replace("https://gdl.grillhouse.mx/?"+'&str='+store);     
    }else if(store=='sal'){
      eraseCookie('store');
      setCookie('store','sal',365);
      window.location.replace("https://www.saltillo.grillhouse.mx/?"+'&str='+store);     
    }else if(store=='qro'){
      eraseCookie('store');
      setCookie('store','qro',365);
      window.location.replace("https://www.qro.grillhouse.mx/?"+'&str='+store);     
    }else if(store=='nac'){
      eraseCookie('store');
      setCookie('store','nac',365);
      window.location.replace("https://www.cdmx.grillhouse.mx/?"+'&str='+store);     
    }else if(store=='chi'){
      eraseCookie('store');
      setCookie('store','chi',365);
      window.location.replace("https://chihuahua.grillhouse.mx/?"+'&str='+store);     
    }else if(store=='mtp'){
      eraseCookie('store');
      setCookie('store','mtp',365);
      window.location.replace("https://metepec.grillhouse.mx/?"+'&str='+store);     
    }else{      
       if(!redirected){
        toggleModal();
      }
      eraseCookie('store');
      setCookie('store','mty',365);     
    }  
  }
  
  var dropdown='<label class="dd-dropdown">'
 +'<div class="dd-button"><i class="marker"></i> Monterrey'
+'<svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">'
      +'<path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>'
    +'</svg>'
+'</div>'
+'<input type="checkbox" class="dd-input" id="test">'
 + '<ul class="dd-menu">'    
  + ' <li class="divider"></li>'
  
   + '<li>'
  +   '<a href="#" id="city_switch_cdmx" ><i class="marker" style="margin-right:3px;"></i> Ciudad de Mexico</a>'
  + ' </li>'
   + '<li style="">'
  +   '<a href="#" id="city_switch_mtp" ><i class="marker" style="margin-right:3px;"></i> Metepec</a>'
  + ' </li>'
     + '<li>'
  +   '<a href="#" id="city_switch_guad" ><i class="marker" style="margin-right:3px;"></i> Guadalajara</a>'
  + ' </li>'
   + '<li>'
  +   '<a href="#" id="city_switch_sal" ><i class="marker" style="margin-right:3px;"></i> Saltillo</a>'
  + ' </li>'
  + '<li style="">'
  +   '<a href="#" id="city_switch_chi" ><i class="marker" style="margin-right:3px;"></i> Chihuahua</a>'
  + ' </li>'
    + '<li>'
  +   '<a href="#" id="city_switch_qro" ><i class="marker" style="margin-right:3px;"></i> Querétaro</a>'
  + ' </li>'
  
     + '<li>'
  +   '<a href="#" id="city_switch_nac" ><i class="marker" style="margin-right:3px;"></i> Envíos Nacionales</a>'
  + ' </li>'
 + '</ul>'  
+'</label>';
  
   var header_nav=document.getElementById('announcement-bar__inner');
      header_nav.innerHTML += dropdown;

var pass_cook= location.search.split('str=')[1];
var redirected=false;
if(pass_cook=== undefined){
console.log('si esta undefined');
}else{
  if(pass_cook== 'mty'){
   redirected=true;
    
    setStore('mty');
  }
}

    function windowOnClick(event) {
        if (event.target === modal) {
            toggleModal();
        }
    } 
  

  //setCookie('tienda','cdmx',1)
//eraseCookie('tienda');
    document.addEventListener("DOMContentLoaded", toggleModal);
    
  var modal = document.querySelector(".stores-modal");
    
    var closeButton = document.querySelector(".stores-close-button");
  //closeButton.addEventListener("click", toggleModal);
    //window.addEventListener("click", windowOnClick); 
  
  
  // var city_switch=document.getElementById('city_switch');
  
 
  
  var cook=getCookie('store');
  
 
  
  if(cook) {
    console.log('si existe cookie: '+cook);
     if(cook=='gdl'){
      
    setStore('gdl');
    }else if(cook=='cdmx'){
      
    setStore('cdmx');
    }   else if(cook=='sal'){
      
    setStore('sal');
    } else if(cook=='qro'){
      
    setStore('qro');
    } else if(cook=='nac'){
      
    setStore('nac');
    } else if(cook=='chi'){
      
    setStore('chi');
    } else if(cook=='mtp'){
      
    setStore('mtp');
    } 

    
  }else{
     console.log('no hay cookie');
    toggleModal();
 
  }
  
var elementCdmx = document.getElementById('city_switch_cdmx');
elementCdmx.onclick = function() {
  setStore('cdmx');
}

var elementGuad = document.getElementById('city_switch_guad');
elementGuad.onclick = function() {
  setStore('gdl');
}

var elementSal = document.getElementById('city_switch_sal');
elementSal.onclick = function() {
  setStore('sal');
}

var elementNac = document.getElementById('city_switch_nac');
elementNac.onclick = function() {
  setStore('nac');
}

var elementQro = document.getElementById('city_switch_qro');
elementQro.onclick = function() {
  setStore('qro');
}
 var elementChi = document.getElementById('city_switch_chi');
elementChi.onclick = function() {
  setStore('chi');
} 
var elementMtp = document.getElementById('city_switch_mtp');
elementMtp.onclick = function() {
  setStore('mtp');
}
  
  var cdmx=document.getElementById('cdmx');
  
  var mty=document.getElementById('mty');
   var nac=document.getElementById('nac');
  var guad=document.getElementById('guad');
  var sal=document.getElementById('sal');
  var qro=document.getElementById('qro');
  var chi=document.getElementById('chi');
  var mtp=document.getElementById('mtp');
  
  cdmx.addEventListener("click", function(){
    setStore('cdmx');
}, false);
  nac.addEventListener("click", function(){
    setStore('nac');
}, false);
  
  mty.addEventListener("click", function(){
    setStore('mty');
}, false);
  
  guad.addEventListener("click", function(){
    setStore('gdl');
}, false);
  sal.addEventListener("click", function(){
    setStore('sal');
}, false);
  qro.addEventListener("click", function(){
    setStore('qro');
}, false);
   chi.addEventListener("click", function(){
    setStore('chi');
}, false);
    mtp.addEventListener("click", function(){
    setStore('mtp');
}, false);
  
}, false);

document.addEventListener("click", (evt) => {
    const flyoutElement = document.getElementsByClassName('dd-dropdown')[0];
    let targetElement = evt.target; 

    do {
        if (targetElement == flyoutElement) {
           
            
            return;
        }
      
        targetElement = targetElement.parentNode;
    } while (targetElement);

  document.getElementById("test").checked = false;
   
});